import de from 'Assets/i18n/de.json';
import en from 'Assets/i18n/en.json';
var TranslateService = /** @class */ (function () {
    function TranslateService() {
    }
    TranslateService.getInstance = function () {
        if (!TranslateService.instance) {
            TranslateService.instance = new TranslateService();
        }
        return TranslateService.instance;
    };
    TranslateService.setLanguage = function (language) {
        TranslateService.language = language;
    };
    TranslateService.getLanguage = function () {
        return TranslateService.language;
    };
    Object.defineProperty(TranslateService, "Translate", {
        get: function () {
            switch (TranslateService.language) {
                case 'de':
                    return de;
                case 'en':
                    return en;
                default:
                    return en;
            }
        },
        enumerable: true,
        configurable: true
    });
    TranslateService.language = '';
    return TranslateService;
}());
export default TranslateService;



//////////////////
// WEBPACK FOOTER
// ./service/translate.service.tsx
// module id = null
// module chunks = 